import { ChatThread } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface ChatThreadsResponse {
  chat_threads: ChatThread[]
}

export interface ChatThreadParams {
  chat_threadable_type?: string
  chat_threadable_id?: string
}

export function createChatThread(context: ApiContext, chat_threadable_type: string, chat_threadable_id: string) {
  return apiContextFetch<ChatThread>(context, `chat_threads`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      chat_threadable_type,
      chat_threadable_id,
    }),
  })
}

export function fetchChatThread(context: ApiContext, id: string) {
  return apiContextFetch<ChatThread>(context, `chat_threads/${id}`)
}

export function fetchChatThreads(context: ApiContext, params?: ChatThreadParams) {
  const searchParams = new URLSearchParams()
  if (params?.chat_threadable_type) {
    searchParams.set("chat_threadable_type", params.chat_threadable_type)
  }
  if (params?.chat_threadable_id) {
    searchParams.set("chat_threadable_id", params.chat_threadable_id)
  }

  const url = `chat_threads${searchParams.toString() ? `?${searchParams.toString()}` : ""}`
  return apiContextFetch<{ chat_threads: ChatThread[] }>(context, url).then((response) => response.chat_threads)
}
